import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import './admin-design.css'
import '../views/moaland/mission/detail/CampaignSourceFilter.css'

export default function AdminDesign() {
  const { pathname } = useLocation()
  useEffect(() => {
    const enabled = (pathname.startsWith('/moaland/manage/') || pathname === '/moaland/dashboard')
    document.documentElement.classList.toggle('kviewo-admin-design', enabled)
    return () => document.documentElement.classList.remove('kviewo-admin-design')
  }, [pathname])
  return null
}
